// extracted by mini-css-extract-plugin
module.exports = {"SkeletonItem":"skeleton_SkeletonItem__Z24wQ","skeleton-shimmer":"skeleton_skeleton-shimmer__rwsq4"};